import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const CATEGORY_COLLISION_MANAGER_NAME = 'CategoryCollisionManager';
export const CATEGORY_COLLISION_MANAGER_SLOTS: Array<
	keyof CategoryCollisionManagerClasses
> = ['root'] as const;

export type CategoryCollisionManagerSlot =
	(typeof CATEGORY_COLLISION_MANAGER_SLOTS)[number];

export interface CategoryCollisionManagerClasses {
	root: string;
}

export type CategoryCollisionManagerClassKey =
	keyof CategoryCollisionManagerClasses;

export const getCategoryCollisionManagerUtilityClass = (slot: string) =>
	generateUtilityClass(
		CATEGORY_COLLISION_MANAGER_NAME,
		slot as CategoryCollisionManagerSlot,
	);

export const categoryCollisionManagerClasses: CategoryCollisionManagerClasses =
	generateUtilityClasses(CATEGORY_COLLISION_MANAGER_NAME, ['root']);

export default categoryCollisionManagerClasses;
